/* Fuzzy — Candy Pop theme scripts */
(function () {
  'use strict';

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return Math.round(cents / 100).toLocaleString('en-US');
        case 'amount_with_comma_separator': return value.replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return Math.round(cents / 100).toLocaleString('de-DE');
        default: return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 });
      }
    });
  }

  /* Mobile menu + search */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-toggle'));
    if (!target) return;
    var open = !target.classList.contains('is-open');
    target.classList.toggle('is-open', open);
    document.querySelectorAll('[data-toggle="' + target.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    if (open) { var f = target.querySelector('input, a, button'); if (f) f.focus(); }
    document.body.style.overflow = (open && target.classList.contains('mobile-nav')) ? 'hidden' : '';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.mobile-nav.is-open, .search-bar.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    document.body.style.overflow = '';
  });

  /* Cart count + toast */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count; el.setAttribute('data-count', count);
    });
  }
  var toastTimer;
  function showToast(text) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(parseInt(input.min || '0', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Delivery estimate: always calculated from today */
  function refreshDelivery() {
    var locale = document.documentElement.lang || 'en';
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 6;
      var max = parseInt(el.getAttribute('data-max'), 10) || 10;
      function at(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
      function fmt(d, o) { try { return d.toLocaleDateString(locale, o); } catch (e) { return d.toDateString(); } }
      var long = { weekday: 'short', month: 'short', day: 'numeric' };
      var short = { month: 'short', day: 'numeric' };
      var map = {
        'start': fmt(at(min), long), 'end': fmt(at(max), long), 'today': fmt(at(0), long),
        'start-short': fmt(at(min), short), 'end-short': fmt(at(max), short),
        'end-month': fmt(at(max), { month: 'short' }).toUpperCase(), 'end-day': String(at(max).getDate())
      };
      el.querySelectorAll('[data-d]').forEach(function (n) {
        var k = n.getAttribute('data-d');
        if (map[k]) n.textContent = map[k];
      });
    });
  }
  refreshDelivery();

  /* Product form: variant picker (photo swatches + pills), gallery sync, AJAX add, sticky bar */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var buttons = root.querySelectorAll('[data-add-button]');
    var gallery = root.querySelector('[data-gallery]');
    var grid = root.querySelector('[data-gallery-grid]');
    var strip = root.querySelector('[data-gallery-strip]');
    var sticky = root.querySelector('[data-sticky]');

    function setButtons(state) {
      buttons.forEach(function (b) {
        if (state === 'busy') { b.disabled = true; b.textContent = 'Adding…'; return; }
        b.disabled = state !== 'ok';
        b.textContent = state === 'ok' ? b.getAttribute('data-add-label') : (state === 'none' ? 'Unavailable' : 'Sold out');
      });
    }
    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('fieldset[data-option-index]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      root.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          input.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function showMedia(id) {
      if (!id) return;
      if (gallery) {
        var thumb = gallery.querySelector('[data-media-id="' + id + '"]');
        if (thumb) thumb.click();
      }
      if (grid) {
        var tile = grid.querySelector('[data-media-tile="' + id + '"]');
        if (tile && tile !== grid.firstElementChild) grid.insertBefore(tile, grid.firstElementChild);
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      }
      if (strip) {
        var t = strip.querySelector('[data-media-tile="' + id + '"]');
        if (t) strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - 16, behavior: 'smooth' });
      }
    }
    function onChange() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) { setButtons('none'); return; }
      idInput.value = v.id;
      setButtons(v.available ? 'ok' : 'soldout');
      var priceHtml = '<span class="price__now">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceHtml += '<s class="price__was"><span class="visually-hidden">Regular price</span>' + formatMoney(v.compare_at_price) + '</s>';
      }
      root.querySelectorAll('.pdp-price [data-price], .product__price [data-price]').forEach(function (el) { el.innerHTML = priceHtml; });
      if (v.featured_media) showMedia(v.featured_media.id);
      if (sticky) {
        var sum = sticky.querySelector('[data-selected-summary]');
        if (sum) sum.textContent = opts.filter(Boolean).join(' · ');
        var sp = sticky.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = formatMoney(v.price);
        var si = sticky.querySelector('[data-sticky-img] img');
        if (si && v.featured_image && v.featured_image.src) { si.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; si.removeAttribute('srcset'); }
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-option-index]')) onChange(); });
    markAvailability(selectedOptions());

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      setButtons('busy');
      fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || 'Could not add to bag');
          return fetch(window.theme.routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { updateCartCount(cart.item_count); showToast('Added to your bag!'); })
        .catch(function (err) { showToast(err.message); })
        .finally(function () {
          var v = product.variants.find(function (x) { return String(x.id) === String(idInput.value); });
          setButtons(v && v.available ? 'ok' : 'soldout');
        });
    });

    /* Sticky bar appears once the main Add to bag button scrolls out of view */
    if (sticky && 'IntersectionObserver' in window) {
      var mainBtn = form.querySelector('[data-add-button]');
      if (mainBtn) {
        new IntersectionObserver(function (entries) {
          var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', hidden);
          sticky.setAttribute('aria-hidden', hidden ? 'false' : 'true');
          sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = hidden ? 0 : -1; });
        }).observe(mainBtn);
      }
    }
  });

  /* Product gallery thumbnails (Showcase + legacy) */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-main-media]');
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-media-id]');
      if (!t || !main) return;
      var img = t.querySelector('img');
      var mainImg = main.querySelector('img');
      if (img && mainImg) {
        mainImg.src = t.getAttribute('data-full');
        mainImg.removeAttribute('srcset');
        mainImg.alt = img.alt;
      }
      g.querySelectorAll('[data-media-id]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    });
  });

  /* Collection sort */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Cart page: auto-update quantities */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var timer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { cartForm.submit(); }, 500);
    });
  }
})();
